import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'

import App from '../shared/App';
import registerServiceWorker from './registerServiceWorker';

import 'bootstrap/dist/css/bootstrap.css';
import '../shared/css/normalize.css';
import '../shared/css/imports.css'
import '../shared/css/font-awesome.css';
import '../shared/css/font-material.css';
import '../shared/css/app.css';
import '../shared/css/calendar.css';

import store from '../shared/store'

ReactDOM.render(
  <Provider store = {store}>
    <BrowserRouter>
      <App />
    </BrowserRouter>
	</Provider>,
  document.getElementById('root')
);

registerServiceWorker();



// WEBPACK FOOTER //
// ./src/client/index.js